import styled from 'styled-components'
import {
	backgroundOrange,
	darkOrange,
	orange,
	gold,
	success,
	dangerHover,
	black,
	textMuted,
	white,
	warmTint,
	border1,
	scrimDark,
} from '@/theme/colors'
import { radii, layers } from '@/theme/tokens'
import { fontSizes, text, leading } from '@/theme/typography'
import { Button } from '@components/Button'
import { Pill } from '@components/Pill'
import { ChatDiscussion } from '@components/Chat'

export const HeaderRow = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 16px;
    background: ${backgroundOrange};
    border-radius: ${radii.inner};
    margin-bottom: 16px;
`

export const ExpenseName = styled.div`
    font-size: ${fontSizes.title};
    font-weight: 700;
    color: ${black};
    text-align: center;
`

export const PaidByRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 4px;
`

export const PaidByLabel = styled.span`
    ${text.eyebrow}
    color: ${textMuted};
`

export const PaidByName = styled.span`
    font-size: ${fontSizes.small};
    font-weight: 500;
    color: ${black};
`


export const AmountRow = styled.div`
    text-align: center;
    margin-bottom: 8px;
`

export const Amount = styled.span`
    font-size: ${fontSizes.display};
    font-weight: 700;
    color: ${darkOrange};
`

export const CurrencyCode = styled.span`
    font-size: ${fontSizes.small};
    font-weight: 500;
    color: ${gold};
    margin-left: 6px;
`

export const DateRow = styled.div`
    text-align: center;
    font-size: ${fontSizes.small};
    color: ${textMuted};
    margin-bottom: 16px;
`

export const InvolvementRow = styled.div<{ $type: 'lent' | 'borrowed' | 'none' }>`
    text-align: center;
    font-size: ${fontSizes.base};
    font-weight: 700;
    color: ${({ $type }) => {
        if ($type === 'lent') return success
        if ($type === 'borrowed') return dangerHover
        return textMuted
    }};
    margin-bottom: 24px;
`

export const SectionTitle = styled.div`
    ${text.eyebrow}
    color: ${textMuted};
    margin-bottom: 8px;
`

export const SplitTypeBadge = styled(Pill).attrs({ $tone: 'gold' as const })`
	margin-left: 6px;
`

export const SplitSection = styled.div`
    margin-bottom: 24px;
`

export const SplitList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const SplitRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    border: 1px solid ${warmTint};
    border-radius: ${radii.small};
    background: ${white};
`

export const SplitName = styled.span`
    flex: 1;
    font-size: ${fontSizes.small};
    color: ${black};
`

export const SplitAmount = styled.span`
    font-size: ${fontSizes.small};
    font-weight: 700;
    color: ${darkOrange};
`

export const ThumbnailGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
    gap: 8px;
    margin-bottom: 24px;
`

export const Thumbnail = styled.div`
    aspect-ratio: 1;
    border-radius: ${radii.small};
    overflow: hidden;
    cursor: pointer;
    border: 1px solid ${border1};

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &:hover {
        border-color: ${orange};
    }
`

export const AuditInfo = styled.div`
    font-size: ${fontSizes.micro};
    color: ${textMuted};
    border-top: 1px solid ${warmTint};
    padding-top: 12px;
    line-height: ${leading.body};
`

export const AuditLine = styled.div`
    margin-bottom: 4px;

    &:last-child {
        margin-bottom: 0;
    }
`

export const FooterActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
`

export const ActionButton = styled(Button).attrs({ size: 'sm' as const })``

export const ImageOverlay = styled.div`
    position: fixed;
    inset: 0;
    background: ${scrimDark};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: ${layers.viewer};
    cursor: pointer;

    img {
        max-width: 90%;
        max-height: 90%;
        object-fit: contain;
    }
`

/** The expense's Discussion, which took the old comments' place. */
export const Discussion = styled(ChatDiscussion)`
    margin-top: 20px;
`
